
const THEMES = {
    LIGHT: "light",
    DARK: "dark"
  };
  
  export default THEMES;